<h1>Promo Codes</h1>

<div class="panel panel-default">
  <div class="panel-heading"><h3 class="panel-title">Filters</h3></div>
  <div class="panel-body">
    <div class="table-nav-menu">
      <ch-select-picker [items]="activeTypes" (change)="statusChanged($event)" value="{{ pageParams.status }}"></ch-select-picker>
      <ch-select-picker [items]="types" (change)="typeChanged($event)" value="{{ pageParams.type }}"></ch-select-picker>
      <ch-search-input (search)="search($event)" value="{{ pageParams.search }}"></ch-search-input>
    </div>
  </div>
</div>

<div class="card">
  <div class="card-header">Promo Codes <a [routerLink]="['/admin/membership-codes/add']" class="btn btn-default pull-right">New</a></div>
  <div class="card-block">
    <div class="table-responsive">
      <div class="loading-cont" *ngIf="loading"><div class="loading-spinner"></div></div>
      <p class="no-items-found" *ngIf="!loading && 0 === items.length">No items found.</p>

      <table class="table table-hover" *ngIf="!loading && 0 < items.length">
        <thead>
          <tr>
            <th class="sortable">
              <span class="col-name"
                >Name
                <ch-sortable [column]="'NAME'" [pageParams]="pageParams" (sort)="onSort($event)"></ch-sortable>
              </span>
            </th>
            <th>
              <span class="col-name"
                >Redemptions
                <ch-sortable [column]="'REDEMPTIONS'" [pageParams]="pageParams" (sort)="onSort($event)"></ch-sortable>
              </span>
            </th>
            <th class="sortable">
              <span class="col-name"
                >Code
                <ch-sortable [column]="'CODE'" [pageParams]="pageParams" (sort)="onSort($event)"></ch-sortable>
              </span>
            </th>
            <th class="sortable">
              <span class="col-name"
                >Type
                <ch-sortable [column]="'STATUS'" [pageParams]="pageParams" (sort)="onSort($event)"></ch-sortable>
              </span>
            </th>
            <th class="sortable">
              <span class="col-name"
                >Expiry Date
                <ch-sortable [column]="'EXPIRY_DATE'" [pageParams]="pageParams" (sort)="onSort($event)"></ch-sortable>
              </span>
            </th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of items; let i = index">
            <td>{{ item.name }}</td>
            <td>{{ item.redemptions }}</td>
            <td>{{ item.code }}</td>
            <td>
              <span *ngIf="'DISCOUNT' === item.type" class="label label-primary">{{ getTypeReadable(item.type) }}</span>
              <span *ngIf="'STAFF_INCENTIVE' === item.type" class="label label-success">{{ getTypeReadable(item.type) }}</span>
              <span *ngIf="'STAFF_INCENTIVE' !== item.type && 'DISCOUNT' !== item.type" class="label label-default">{{
                getTypeReadable(item.type)
              }}</span>
            </td>
            <td>{{ item.expiryDate | dateFormat }}</td>
            <td class="col-md-1">
              <a class="btn btn-primary" [routerLink]="['/admin/membership-codes/edit']" [queryParams]="{ id: item.id }">Edit</a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div>
  <div class="page-bottom-container action-buttons">
    <ch-pagination-dropdown
      *ngIf="!loading"
      [totalItems]="totalItems"
      [pageNumber]="pageParams.pageNumber"
      [pageSize]="pageParams.pageSize"
      (pageChanged)="onPageChanged($event)"
    ></ch-pagination-dropdown>
  </div>
</div>



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/promo-code/promo-code-listing/promo-code-listing.component.html